import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@material-ui/core";
import { useObjectivesList } from "../../../hooks/useObjectivesList";
import { Form } from "./components/Form";
import { ObjectiveSelect } from "../../../components/ObjectiveSelect";
import { withTranslation } from 'react-i18next';
export const FormRegistrosPlus = withTranslation()(function FormRegistrosPlus({ defaultObjective, t }) {
    const {
        data: objectivesList,
        isLoading: isLoadingObjectiveList,
    } = useObjectivesList({ fromStorage: false });
    const [objectiveId, setObjectiveId] = React.useState("");
    const [service, setService] = React.useState("");

    function handleChangeObjective(newValue) {
        setObjectiveId(newValue);
        const objetiveFindService = objectivesList.find(
            (item) => item.objetivo_id === newValue
        );
        if (objetiveFindService) {
            setService(objetiveFindService.servicio_id);
        }
    }

    const objectivesListFiltered = React.useMemo(() => {
        return objectivesList.filter(
            (item) =>
                item.servicio_id === 700 ||
                (item.servicio_id >= 290 && item.servicio_id <= 299) ||
                (item.servicio_id >= 270 && item.servicio_id <= 279) ||
                (item.servicio_id >= 250 && item.servicio_id <= 259)
        );
    }, [objectivesList]);

    React.useEffect(() => {
        if (defaultObjective) {
            const objetiveFind = objectivesList.find(
                (item) => item.objetivo_id === Number(defaultObjective)
            );
            if (objetiveFind) {
                setObjectiveId(defaultObjective);
                setService(objetiveFind.servicio_id);
            }
        }
    }, [objectivesList, defaultObjective]);

    return (
        <Box>
            <Box maxWidth={400} minWidth={300}>
                <ObjectiveSelect
                    objetivos={objectivesListFiltered}
                    objetivoId={objectiveId}
                    setObjetivoId={handleChangeObjective}
                    isLoading={isLoadingObjectiveList}
                />
                {isLoadingObjectiveList && (
                    <Typography variant="body2" style={{ marginTop: 5 }}>
                        {t('formRegistros.loading.objectives')}
                    </Typography>
                )}
            </Box>
            <Box marginTop={2}>
                <Form objetivoId={objectiveId} servicioId={service} />
            </Box>
        </Box>
    );
});
